import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutUs } from './components/AboutUs';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { TherapistProfiles } from './components/TherapistProfiles';
import { Testimonials } from './components/Testimonials';
import { BookingCTA } from './components/BookingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#faf7f2]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutUs data-id="element-4" />
        <Services data-id="element-5" />
        <WhyChooseUs data-id="element-6" />
        <TherapistProfiles data-id="element-7" />
        <Testimonials data-id="element-8" />
        <BookingCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}